<template>
  <div class="years">

    


    <YearsNav></YearsNav>

      <transition name="fade" mode="out-in">
        <keep-alive>
          <router-view style="animation-duration: .5s"></router-view>
        </keep-alive>
      </transition>


  </div>
</template>

<script>
// @ is an alias to /src
import Flickity from 'vue-flickity';
import YearsNav from '@/components/YearsNav.vue'
import axios from 'axios';


export default {
  name: 'year',
  components: {
    YearsNav
  }, 
  data() {
    return {
      tds: {}
    } 
  },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data;
      this.y2001 = response.data.y2001;
      this.y2002 = response.data.y2002;
      this.y2003 = response.data.y2003;
      this.y2004 = response.data.y2004;
      this.y2005 = response.data.y2005;
      this.y2006 = response.data.y2006;
      this.y2007 = response.data.y2007;
      this.y2008 = response.data.y2008;
      this.y2009 = response.data.y2009;
      this.y2010 = response.data.y2010;
      this.y2011 = response.data.y2011;
      this.y2012 = response.data.y2012;
      this.y2013 = response.data.y2013;
      this.y2014 = response.data.y2014;
      this.y2015 = response.data.y2015;
      this.y2016 = response.data.y2016;
      this.y2017 = response.data.y2017;
      this.y2018 = response.data.y2018;
      this.y2019 = response.data.y2019;
    }
  },
  mounted() {
  }
}

</script>

<style>
.youtube-external-link {
  border-bottom: 3px solid #D3BC8D;
  transition-duration: .25s;
  text-decoration:none;
  color:black;
  line-height: 29px;
}

.youtube-external-link:hover {
transition-duration: .25s;
background: #D3BC8D;
}


.chart-headline {
    width: 90%;
    margin:30px auto;
    font-family: 'Teko', sans-serif;
    transform: skewX(-12deg);
    line-height: 72px;
    font-size: 70px;
    text-transform: uppercase;
    text-align:center;
}


.bubble-chart-wrapper {
width:100%;
max-width:1200px;
margin:0 auto;
padding-bottom:100px;
}

.touchdowns-header-wrapper {
    background: black;
    background: linear-gradient(to bottom, #000000 0%,#212121 100%);
}

.touchdowns-header-wrapper > h1 {
    margin: 0px;
    font-family: 'Teko', sans-serif;
    font-size: 84px;
    text-align: center;
    color: white;
    height: 150px;
}

.touchdowns-header-wrapper > h1 > img {
    height: 100px;
    position: relative;
    top: 16px;
}


.year-pagination-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    box-shadow: inset 0px 12px 30px -10px #00000085;
    background: #d3bc8c;
    margin-bottom: 35px;
}

.year-pagination-section {
    width: 33.33333%;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
      font-family: 'Teko', sans-serif;
  font-weight: 700;
  font-size: 80px;
}

.year-pagination-section.year-pagination-prev {
    box-shadow: 6px 0px 34px -16px black;
}

.year-pagination-section.year-pagination-next {
    box-shadow: -6px 0px 34px -16px black;
}


.year-pagination-section > a {
    color: #000000;
    text-decoration: none;
    position: relative;
    top: 6px;
}

.year-pagination-current {
    /* width: 33%; */
    color: #ffffff;
    text-decoration: underline;
        background: black;
}




.view-wrap {
    background: white;
    height:100%;
    width:100%;
    max-width:1920px;
    margin:auto;
    /* padding-left: 500px; */
    text-align: left;
    font-size: 18px;
    color: black;
    padding-top:0px;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position-x: 0px;
    /* box-shadow: 9px -16px 55px 22px black; */
    position: relative;
}

.view-content {
    background: rgba(0, 0, 0, 0.75);
    padding-left: 20px;
    padding-bottom: 20px;
}

.year-top-image {
    height: 550px;
    /*background-size: cover;*/
    background-repeat: no-repeat;
    background-position: top center;
    position: relative;
    overflow:hidden;
}

.year-main-content {
    padding-top: 40px;
}

.year-overlay {
  width: 350px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #D3BC8D;
  position: absolute;
  text-align: center;
  line-height: 68px;
  letter-spacing: 3px;
  color: #000000;
  -webkit-transform: rotate(-45deg);
  top: auto;
  right: -90px;
  bottom: 27px;
  left: auto;
  font-family: 'Teko', sans-serif;
  font-weight: 700;
  font-size: 80px;
  box-shadow: 0px 0px 70px 12px black;
  border-top: 7px solid black;
  border-bottom: 7px solid black;
  background: linear-gradient(180deg,#dbcf9b 0,#d3bc8d 50%,#bfa980 51%,#d3bc8d);
}

.year-overlay > span {
    position: relative;
    top: 5px;
}


p {
  font-size:24px;
}



.carousel-cell {
    height: 600px;
    background-color: #000;
    overflow: hidden;
}

.carousel-cell-bg-style {
    width: 100%;
    height: 100%;
    min-height: 600px;
    background-color: #000;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}



.year-img {
  position:fixed;
  top:0;
  left:-60px;
}



.stats-wrap {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.stat-single-wrap {
    background: #D3BC8D;
    width: 24%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 140px;
    flex-direction: column;
    text-transform: uppercase;
    font-size: 14px;
}

.stat-single-wrap > span {
    font-size: 50px;
    font-weight: 700;
}


.awards-wrapper {
    padding: 0px;
    width: 100%;
}


.awards-headline {
  width: 90%;
    margin: 0px 0px;
    font-family: 'Teko', sans-serif;
    -webkit-transform: skewX(-12deg);
    transform: skewX(-12deg);
    line-height: 72px;
    font-size: 70px;
    padding: 15px 15px 0px 15px;
    text-transform: uppercase;
}


.awards-legend {
    background: #f2f2f2;
    font-size: 12px;
    padding: 20px;
    margin-top: 15px;
}


.awards-wrapper > ul {
  display: flex;
  justify-content: space-between;
    flex-wrap: wrap;
    list-style: none;
    padding: 0px 10px;
    margin:0px;

}

.awards-wrapper li {
  width: 48%;
  min-height: 30px;
  display:flex;
  justify-content:flex-start;
  align-items:center;
  list-style: none;
    padding: 10px 0px;
    line-height: 19px;
    font-weight: 700;
    border-top: 2px dotted #e0e0e0;
}

.awards-wrapper li:last-of-type {
    border-bottom: 2px dotted #e0e0e0;
}
.awards-wrapper li:nth-last-child(2) {
    border-bottom: 2px dotted #e0e0e0;
}

.awards-wrapper img {
  width:40px;
  margin-right:10px;
}



@media (max-width:1024px) {

  .bubble-chart-wrapper {
width:100%;
max-width:650px;
margin:0 auto;
padding-bottom:100px;
}




.awards-legend {
    font-size: 10px;

}

  .year-top-image {
    height: 350px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    position: relative;
    overflow:hidden;
}
  .view-wrap {
    padding-left: 0px;
    background-position-x: -160px;
    background-position-y: 190px;
}
.year-main-content {
    padding-top: 98px;
}

.touchdowns-header-wrapper > h1 {
    font-size: 64px;
}


.year-main-content {
    padding-top: 98px;
}



.stat-single-wrap {
    font-size: 10px;
}

.year-pagination-section {
  font-size: 45px;

}

.chart-headline {
    width: 80%;
    margin: 20px auto;
    margin-bottom: 0px;
    line-height: 30px;
    font-size: 30px;
}


}






@media (max-width:767px) {
  .stat-single-wrap > span {
    font-size: 20px;
}


.carousel-cell {
    height: 300px;
    background-color: #000;
}

.carousel-cell > img {
height: 300px;
}

  .view-wrap {
    padding-left: 0px;
    padding-right:0px;
    padding-top: 0px;
    background-position-x: -160px;
    background-position-y: -180px;
    /*box-shadow: 0px 10px 21px 26px black;*/
}
.year-top-image {
    margin-top: 34px;
}

.touchdowns-header-wrapper > h1 {
    font-size: 30px;
}


.awards-wrapper > ul {
flex-direction:column;
}

.awards-wrapper li {
  width: 100%;
  padding: 6px 0px;
  line-height: 12px;
  font-size: 12px;
}

  .awards-wrapper li:nth-last-child(2) {
    border-bottom: none;
}



}


@media (max-width:700px) {
  .year-main-content {
    padding-top: 0px;
}

.year-pagination-section {
    height: 65px;
    }

.touchdowns-header-wrapper > h1 {
    font-size: 26px;
    height: initial;
    line-height: 80px;
}

.touchdowns-header-wrapper > h1 > img {
    height: 46px;
}

.year-overlay {
    width: 260px;
    height: 60px;
    right: -80px;
    bottom: 17px;
    font-size: 50px;
}

.year-overlay > span {
    top: 3px;
}

.awards-headline {
    font-size: 60px;
}

}


@media (max-width:374px) {
.year-top-image {
    height: 442px;
}
.year-pagination-section {
    font-size: 30px;
    height:80px;
}

.touchdowns-header-wrapper > h1 {
   font-size: 26px;
}

}








</style>


// WEBPACK FOOTER //
// src/views/Year.vue